  import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
  import {  ViewChild, ViewEncapsulation } from "@angular/core";
  import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
  import { ApiService } from 'app/shared/services/api.service';
  import { environment } from 'environments/environment';
  import { ToastrService } from 'ngx-toastr';
  import swal from 'sweetalert2'
  import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss','../../../../../../assets/sass/libs/datatables.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class NotificationListComponent implements OnInit {
      @ViewChild(DatatableComponent) table: DatatableComponent;
      page = {
        pageNumber:0,
        offset: 0,
        pageSize: 100,
        totalPages:0
      };
      // row data
      public rows = [];
      public filterRows=[];
      public ColumnMode = ColumnMode;
      public limitRef = 10;
      selectedValue=''
      isFilter:boolean=false;
      isVerified:boolean=false;
      // column header
      public columns = [
        { name: "User", prop: "user" },
        { name: "Title", prop: "title" },
        { name: "Description", prop: "description" },
        { name: "IsRead", prop: "isRead" },
        { name: "Actions", prop: "Actions" },
      ];
    
      // private
      private tempData = []; 
      imageUrl = environment.apiUrls.imageUrl;
      notification_id:any;
      user_role:any
      guideline_data:any
      
      constructor( public apiService:ApiService,
                   public toastr: ToastrService,private modalService: NgbModal,) { 
                   this.user_role = JSON.parse(localStorage.getItem('user'))
                   let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                   let key_data = setting_data.filter((item) => item.key == 'Notifications')
                   this.guideline_data = key_data[0]?._id
                    }
    
      ngOnInit(): void {
        this.getNotificationList()
      }
     getNotificationList(){
      this.apiService.getNotificationList(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
      })
     }
     editNotification(id:any){
      // console.log('category id ==>>',id)
     }
    pageChangeData(page:any){
      this.apiService.getAttendanceList(page.offset +1,page.pageSize).subscribe((res:any)=>{
        // console.log('pagechange',res)
        this.rows =res.data.items   
        this.page.totalPages=res.data.totalCount
    
      })
    }
      
       // Public Methods
      // -----------------------------------------------------------------------------------------------------
    
      /**
       * filterUpdate
       *
       * @param event
       */
       filterUpdate(event) {
        const val = event.target.value.toLowerCase();
    
        // filter our data
        const temp = this.tempData.filter(function (d) {
          return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
        });
    
        // update the rows
        this.rows = temp;
        this.filterRows=temp
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
      }
    
      /**
       * updateLimit
       *
       * @param limit
       */
      updateLimit(limit) {
        this.limitRef = limit.target.value;
        this.apiService.getNotificationList(1,this.limitRef).subscribe((res:any)=>{
          // console.log('pagechange',res)
          this.rows =res.data.users   
        })
      }
      deleteNotification(){
        if(this.notification_id){
          this.apiService.deleteNotification(this.notification_id).subscribe((res:any)=>{
            // console.log(res)
            if(res.statusCode === 200){
              this.getNotificationList()
            }
            else{
              this.toastr.error(res.error)
            } 
            })
        }
        else{
          this.toastr.error('something went wrong !!')
        }
      }
       // ================== Delete Alert ========================
       ConfirmColor(id:any) {
        this.notification_id=id
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2F8BE6',
          cancelButtonColor: '#F55252',
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-danger ml-1'
          },
          buttonsStyling: false,
        }).then( (result)=> {
          if (result.value) {  
            this.deleteNotification()      
            swal.fire({
              icon: "success",
              title: 'Deleted!',
              text: 'Your imaginary file has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          } else if (result.dismiss === swal.DismissReason.cancel) {
            swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        });
      }
      
      // ==========================================
      openDynamicModal(key_id:string) {
        const modalOptions: NgbModalOptions = {
          size: 'lg', // 'sm', 'lg', or 'xl'
          backdrop: 'static',
        };
        const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
        modalRef.componentInstance.key_id = key_id;
      }
    }
    
  
